import { render } from "./search-2.vue?vue&type=template&id=31521eb4&scoped=true"
import script from "./search-2.vue?vue&type=script&lang=js"
export * from "./search-2.vue?vue&type=script&lang=js"

import "./search-2.vue?vue&type=style&index=0&id=31521eb4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31521eb4"]])

export default __exports__